<template>
  <div class="container">

    <div class="mt-4 mb-2 d-flex justify-content-between">
      <back-arrow :bilan-type="bilanType" :params="{operationId: operationId}" :title="$t('Operation.documents')"
                  ask
                  :sub-title-ope="name"
                  routeBack="OperationShow"/>
    </div>

    <b-row v-if="!dossier.title" align-h="center" class="row mx-0">
      <div class="col-md-5 text-center">
        <img :src="require(`@/assets/images/APRILYOS/empty-table.png`)" alt="no result" class="mt-4 mb-2 no-result-img"
             style="max-height: 25%;">

        <div class="main-color-text-text bold-text level-two-title">
          {{ $t('operation.dossier.emptyTitle') }}
        </div>

        <div class="main-color-text">
          {{ $t('operation.dossier.emptySubtitle.first') }}
        </div>

        <div class="main-color-text">
          {{ $t('operation.dossier.emptySubtitle.second') }}
        </div>

        <b-button class="my-2" variant="primary" @click="clickOnCreateBtn">
          {{ $t('operation.dossier.create') }}
        </b-button>
      </div>
    </b-row>

    <b-row v-else class="row mx-0">
      <div class="col-sm-12 col-md-5 col-lg-4" style="border: 1px solid gray; max-width: 100%;height: auto; min-width: 200px; min-height: 200px; display: flex; justify-content: center;align-items: center">
        <img
          :src="this.dossier.logo ? getFileUrl(this.dossier.logo.fileUrl) : require(`@/assets/images/APRILYOS/emptyState.png`)"
          alt="logo"
          class="no-result-img" style="max-width: 100%;height: auto;">
      </div>
      <div class="col-sm-12 col-md-7 col-lg-8 pl-md-0 pl-lg-2">
        <div class="row mt-4 no-gutters">
          <h6 class="font-weight-bolder h6 text-left">{{ $t('operation.dossier.explanation.project') }}</h6>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="pr-md-2 pr-lg-2 min-vh-50">
              <div
                v-if="handleNull"
                v-html="this.dossier.investment.explication"></div>
              <div v-else>
                {{ $t('operation.dossier.explanation.empty') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-md-12">
            <b-button class="my-2 w-25 w-md-100" variant="primary" @click="generatePdf">
              <span v-if="!loadingPdf">{{ $t('dossierOperation.download.pdf') }}</span>
              <b-spinner v-else label="Loading..." small></b-spinner>
            </b-button>
            <b-button class="my-2 w-25 w-md-100" variant="primary" @click="generateWord">
              <span v-if="!loadingWord">{{ $t('dossierOperation.generate.word') }}</span>
              <b-spinner v-else label="Loading..." small></b-spinner>
            </b-button>
            <b-button class="my-2 w-25 w-md-100" variant="outline-primary" @click="clickOnCreateBtn">
              {{ "Modifier" }}
            </b-button>
          </div>
          <div v-if="loadingWord || loadingPdf" class="mt-2">
            <b-icon icon="info-circle" variant="primary"></b-icon>
            {{ $t('dossierOperation.loading.message') }}
          </div>
        </div>


      </div>
    </b-row>


  </div>
</template>

<script>
import api from "../../../services/api";
import BackArrow from "../../../components/b122/BackArrow.vue";


export default {
  name: "OperationShowDossier",
  components: {BackArrow},

  async mounted() {
    await this.getOperation()
    if (this.dossierOperationCreationDone) {
      await this.fetchDossier()
    }
    if(this.operationId){

    }
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      name: "",
      dossierOperationCreationDone: false,
      dossier: {
        id: null,
        footer: undefined,
        investmentCreationDone: false,
        fundingRequestCreationDone: false,
        financialCreationDone: false,
        primaryColor: undefined,
        title: undefined,
        situationCreationDone: false,
        secondaryColor: undefined,
        logo: null
      },
      bilan: false,
      loadingWord: false,
      loadingPdf: false,
      bilanType: null,
      operationName:null,
    }
  },

  methods: {

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.name = response.data.name
            this.bilanType = response.data.bilanType
            this.dossierOperationCreationDone = response.data.dossierOperationCreationDone
          })
      }
    },

    async fetchDossier() {
      await api
        .get(`/dossierOperation/getDossierByOperation/${this.operationId}`)
        .then(response => {
          this.dossier = response.data
        })
    },

    generatePdf() {
      this.loadingPdf = true

      api.post(`/dossierOperation/downloadPdf/${this.dossier.id}`, {}, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Dossier_${this.name}_${new Date().toLocaleDateString('fr-FR')}.pdf`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loadingPdf = false
      }).catch(() => {
        this.loadingPdf = false
      })
    },


    generateWord() {
      this.loadingWord = true

      api.post(`/dossierOperation/downloadWord/${this.dossier.id}`, {}, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Dossier Banque-${new Date().toLocaleDateString('fr-FR')}.docx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loadingWord = false
      }).catch(() => {
        this.loadingWord = false
      })
    },


    clickOnCreateBtn() {
      this.$router.push({
        name: 'OperationDossierCreateEdit',
        params: {
          operationId: this.operationId,
          dossier: this.dossier,
          dossierOperationCreationDone: this.$route.params.dossierOperationCreationDone
        }
      })
    },


    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

  },

  computed: {
    handleNull() {
      return this.dossier && this.dossier.investment && this.dossier.investment.explication
        && this.dossier.investment.explication !== '<p> </p>'
        && !this.dossier.investment.explication.includes('<p>null</p>')
        && this.dossier.investment.explication !== 'null' && this.dossier.investment.explication !== null;
    },
    dossierCompleted() {
      return this.dossier.investmentCreationDone && this.dossier.fundingRequestCreationDone && this.dossier.financialCreationDone && this.dossier.situationCreationDone
    }
  }
}
</script>

<style scoped>
.no-result {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowDossier.vue